export const convertWidgetData = () => ({
  deviceType: {
    title: 'Устройство',
    slug: 'deviceTypes',
    data: [],
  },
  brand: {
    title: 'Бренд',
    slug: 'brands',
    data: [],
  },
  model: {
    title: 'Модель',
    slug: 'models',
    data: [],
  },
  capacity: {
    title: 'Память',
    slug: 'capacity',
    data: [],
  },
});
